<template>
    <div class="page">
        <div class="top">
            <van-divider
                :style="{ color: '#000', fontSize: '16px', borderColor: '#C4C4C4', fontFamily: 'PingFangSC, PingFang SC' }">PLUS尊享特权
                让你订购更省钱</van-divider>
            <div class="img-flex">
                <div class="items">
                    <img src="@/assets/home/33.png" alt="" />
                    <div class="title">笔笔减</div>
                    <div class="small-title">套餐减免</div>
                </div>
                <div class="items">
                    <img src="@/assets/home/34.png" alt="" />
                    <div class="title">好运转转转</div>
                    <div class="small-title">幸运大转盘</div>
                </div>
                <div class="items">
                    <img src="@/assets/home/31.png" alt="" />
                    <div class="title">月月可领</div>
                    <div class="small-title">每月礼包</div>
                </div>
                <div class="items">
                    <img src="@/assets/home/32.png" alt="" />
                    <div class="title">专属1V1</div>
                    <div class="small-title">会员专享</div>
                </div>
            </div>
        </div>
        <div class="order">
            <van-divider
                :style="{ color: '#000', fontSize: '16px', borderColor: '#C4C4C4', fontFamily: 'PingFangSC, PingFang SC' }">订购周期</van-divider>
            <div class="order-flex">
                <div class="order-item" v-for="(item, index) in list" :key="index" :class="{ 'acvite': inx === index }"
                    @click="priceClick(item, index)">
                    <div class="order-name">{{ item.label }}</div>
                    <div class="order-price">¥{{ item.value }}</div>
                </div>
            </div>
        </div>
        <div class="order1">
            <div class="btn-flex">
                <div class="btn-t">
                    <div class="left">
                        <div class="left-n">套餐立减权益 <img src="@/assets/home/35.png" /></div>
                        <div class="left-m">预计可省<span>¥120～600元</span></div>
                    </div>
                    <div class="right">
                        <div class="right-b" @click="sumbit">开通立享</div>
                    </div>
                </div>
                <div class="btn-f">订购指定基础套餐享立减10元</div>
            </div>
        </div>
        <div class="order1">
            <div class="btn-flex">
                <div class="btn-t">
                    <div class="left">
                        <div class="left-n">不定期抽奖权益 <img src="@/assets/home/35.png" /></div>
                    </div>
                    <div class="right">
                        <div class="right-b" @click="sumbit">开通立享</div>
                    </div>
                </div>
                <div class="btn-f">奖池：iPhone15 Pro Max；100元话费充值卡；66元账号余额；50G流量包；</div>
            </div>
        </div>
        <div class="order1">
            <div class="btn-flex">
                <div class="btn-t">
                    <div class="left">
                        <div class="left-n">每月礼包 <img src="@/assets/home/35.png" /></div>
                    </div>
                    <div class="right">
                        <div class="right-b" @click="sumbit">开通立享</div>
                    </div>
                </div>
                <div class="btn-f">每月购买套餐，格外赠送10G流量包</div>
            </div>
        </div>

        <div class="order1">
            <div class="btn-flex">
                <div class="btn-t">
                    <div class="left">
                        <div class="left-n">专属客服 <img src="@/assets/home/35.png" /></div>
                    </div>
                    <div class="right">
                        <div class="right-b" @click="sumbit">开通立享</div>
                    </div>
                </div>
                <div class="btn-f">会员专享1V1服务，专属客服不定期举行充值、福利红包等趣味游戏</div>
            </div>
        </div>
        <div class="footer">
            <div class="sumbit" @click="sumbit">立即支付 ¥88/年</div>
            <div class="d-v">服务保障 | <span>安心购买</span></div>
            <div class="f-v">
                <van-checkbox v-model="checked" shape="square" />
                我已阅读并同意
                <span @click="bbbb">《PLUS会员用户协议》</span>
            </div>
        </div>




        <div v-html="payUrl"></div>
        <div class="shareit" v-if="is_WeChat">
            <img class="arrow" src="@/assets/img/arrowhead.png" />
            <div class="follow">
                支付宝支付请右上角点击 在游览器打开 进行支付,<br />支付成功后
                请重新扫码登录进行激活操作<br />
            </div>
        </div>

    </div>
</template>
<script>
import { wxRequest } from '@/api/user'
import { Dialog, Toast } from 'vant';
export default {
    data() {
        return {
            PayImgUrl: localStorage.getItem("PayImgUrl"), //页面地址
            is_WeChat: false,
            payUrl: "",

            inx: 0,
            checked: false,
            list: [{ value: "88", label: '1年会员' }] //,{value:"88",label:'1年会员'},{value:"88",label:'1年会员'}
        }
    },
    created() {
        this.is_WeChat = false;
        if (this.$route.query.row) {
            this.payUrl = JSON.parse(decodeURIComponent(this.$route.query.row));
            this.$nextTick(() => {
                document.forms[0].submit();
            });
        }
    },
    methods: {
        //立即支付
        async sumbit() {
            if (!this.checked) {
                Toast('请勾选协议！')
                return
            }
            var params = {
                ali:localStorage.getItem("htmlType"),
                iccid: this.$store.state.iccid ? this.$store.state.iccid : localStorage.getItem("iccid"),
                payType: 20, //固定值
            };
            await wxRequest("sim/pay/type/vip", params, "post").then((res) => {
                if (res.data.code == 406) {
                    params.payType = 60;
                } else if (res.data.code == 408) {
                    params.payType = 80;
                } else if (res.data.code == 409) {
                    params.payType = 90;
                } else if (res.data.code == 410) {
                    params.payType = 90;
                } else if (res.data.code == 491) {
                    params.payType = 90;
                } else if (res.data.code == 492) {
                    params.payType = 92;
                }else if (res.data.code == 493) {
                    params.payType = 93;
                }else if (res.data.code == 494) {
                    params.payType = 94;
                }
            });
            await wxRequest("order/create/vip/order", params, "post").then((res) => {
                if (res.data.code == 200) {
                    if (params.payType == 50) {
                        //乐刷de
                        window.location.href = res.data.data.jspay_url;
                    } else if (params.payType == 92||params.payType == 93||params.payType == 94) {
                        //云游
                        window.location.href = res.data.data;
                    } else if (params.payType == 20) {
                        //微信第三方
                        var param = res.data.data.param;
                        if (typeof WeixinJSBridge == "undefined") {
                            if (document.addEventListener) {
                                document.addEventListener(
                                    "WeixinJSBridgeReady",
                                    this.onBridgeReady,
                                    false
                                );
                            } else if (document.attachEvent) {
                                document.attachEvent("WeixinJSBridgeReady", this.onBridgeReady);
                                document.attachEvent(
                                    "onWeixinJSBridgeReady",
                                    this.onBridgeReady
                                );
                            }
                        } else {
                            this.onBridgeReady(param);
                        }
                    } else if (params.payType == 90) {
                        //微信第三方
                        var param = res.data.data;
                        if (typeof WeixinJSBridge == "undefined") {
                            if (document.addEventListener) {
                                document.addEventListener(
                                    "WeixinJSBridgeReady",
                                    this.onBridgeReady,
                                    false
                                );
                            } else if (document.attachEvent) {
                                document.attachEvent("WeixinJSBridgeReady", this.onBridgeReady);
                                document.attachEvent(
                                    "onWeixinJSBridgeReady",
                                    this.onBridgeReady
                                );
                            }
                        } else {
                            this.onBridgeReady(param);
                        }
                    } else if (params.payType == 60) {
                        //汇付天下
                        let datas = JSON.parse(res.data.data);
                        if (datas.status === "succeeded") {
                            let payment = datas;
                            AdaPay.doPay(payment, (res) => {
                                Dialog.alert({ title: "提示", message: res.result_message });
                            });
                        }
                    } else if (params.payType == 80) {
                        var ua = window.navigator.userAgent.toLowerCase();
                        if (ua.match(/MicroMessenger/i) == "micromessenger") {
                            //进入引导页
                            this.is_WeChat = true;
                            var timer = setInterval(() => {
                                clearInterval(timer);
                                this.$router.push({
                                    path: "/user/userAgreement",
                                    query: {
                                        row: encodeURIComponent(JSON.stringify(res.data.data)),
                                    },
                                });
                            }, 1000);
                        } else {
                            this.payUrl = res.data.data;
                            this.$nextTick(() => {
                                document.forms[0].submit();
                            });
                        }
                    }
                } else {
                    Dialog.alert({ message: res.data.message });
                }
            });
        },

        onBridgeReady(param) {
            let _this = this;
            WeixinJSBridge.invoke(
                'getBrandWCPayRequest', param,
                function (res) {
                    if (res.err_msg == "get_brand_wcpay_request:ok") {
                        if(this.newHome==1||this.newHomes==1){
                                 _this.$router.push({
                        path: '/newUser/home',
                        query: {
                        iccid: _this.$store.state.iccid
                        }
                    }).catch(() => {

                    });
                        }else{
                             _this.$router.push({
                        path: '/newUser/home',
                        query: {
                        iccid: _this.$store.state.iccid
                        }
                    }).catch(() => {

                    });
                        }
                    }
                }
            );
        },

        priceClick(data, i) {
            this.inx = i
        },
        activate() { },
        bbbb() {
            Dialog.confirm({
                title: 'PLUS会员协议',
                width: '90%',
                showCancelButton: false,
                messageAlign: 'left',
                confirmButtonColor: '#ee0a24',
                message: `<span style="color:#f02b2b;">请认真阅读并理解以下内容，其中以加粗方式显著标识的文字，请着重阅读、慎重考虑。</span>
            
本协议是您与本公司所有者（以下简称为"本司"）之间就PLUS会员所订立的契约。请您仔细阅读本协议，您勾选"已阅读并同意"选项后，本协议即构成对双方有约束力的法律文件。

<span style="font-size: 19px;color:#000; font-weight: 700;padding:10px 0;">第1条 相关定义</span>

<b style="color:#000; font-weight: 700;">1.1PLUS会员：</b>PLUS会员是为客户打造的高级会员服务，通过提供高品质的客户服务，让订购变的更加方便，省钱和放心。

<b style="color:#000; font-weight: 700;">1.2PLUS会员正式期：</b>享受PLUS年卡365天本司PLUS会员资格，并可享受本司所提供的相关服务。

<span style="font-size: 19px;color:#000; font-weight: 700;padding:10px 0;">第2条 本站服务条款的确认和接纳</span>

2.1本站所提供的PLUS会员所有权和运作权归本司所有。

2.2用户点击同意本协议的，即视为用户确认自己同意接受PLUS会员相关服务的条款，且同意按本协议内容履行，如产生用户相关责任的，同意承担相应法律责任。

2.3如果您在18周岁以下，您只能在父母或监护人的监护参与下方能参与体验该服务。

2.4本司保留在中华人民共和国大陆地区法施行之法律允许的范围内独自决定拒绝服务、关闭用户账户、清除或编辑内容等相关权利。

<span style="font-size: 19px;color:#000; font-weight: 700;padding:10px 0;">第3条PLUS会员权益</span>

您成为本司PLUS正式期后，可享受的正式期会员权益以本司官方网站公布的信息为准。为更好的向会员提供服务，本司有权基于自身业务发展需要调整全部或部分会员权益。本司就前述权益调整将在相应服务页面进行通知或公告，您可以通过本司官方网站查询最新的会员权益内容。

<span style="font-size: 19px;color:#000; font-weight: 700;padding:10px 0;">第4条 用户会员使用注意事项</span>

4.1提交申请开通时，用户同意并提交本人手机号码或邮箱等本站所需的个人资料，并保证其提供的注册资料真实、准确、完整、合法有效，用户注册资料如有变动的，应及时更新其注册资料。如果用户提供的注册资料不合法、不真实、不准确、不详尽，用户需承担因此引起的相应责任及后果，并且本司保留终止用户参与该活动的权利。

4.2服务开通后，用户应谨慎合理的保存、使用其用户名和密码，不得将在本站注册获得的账户借给他人使用，否则用户应承担由此产生的全部责任，同时本司在该种情况下有权做出独立判断，可采取暂停或关闭用户参与资格等措施。

4.3用户同意，本司拥有通过邮件、短信电话等形式，向其发送相关活动信息等必要信息的权利。

<span style="font-size: 19px;color:#000; font-weight: 700;padding:10px 0;">第5条 协议更新及用户关注义务</span>

根据国家法律法规变化及网站运营需要，<b style="color:#000; font-weight: 700;">本司有权以网站公告的方式进行不定期地制定、修改本协议及/或相关服务规则，暂停、取消和修改本协议条款，修改后的协议一旦被公告在本站上即生效，并代替原来的协议。用户应及时关注不时发布的各项服务规则及本协议的变更。若不同意相关规则及条款修改的，应及时终止与本站的协议。如用户继续使用本网站提供的服务的，即视为同意更新后的协议。本司建议您在使用本站之前阅读本协议及本站的公告。</b>

<span style="font-size: 19px;color:#000; font-weight: 700;padding:10px 0;">第6条 法律管辖和适用</span>

本司有权以网站公告的方式进行不定期地制定、修改本协议及/或相关服务规则，暂停、取消和修改本协议条款，修改后的协议一旦被公告在本站上即生效，并代替原来的协议。用户应及时关注不时发布的各项服务规则及本协议的变更。若不同意相关规则及条款修改的，应及时终止与本站的协议。如用户继续使用本网站提供的服务的，即视为同意更新后的协议。本司建议您在使用本站之前阅读本协议及本站的公告。

<span style="font-size: 19px;color:#000; font-weight: 700;padding:10px 0;">第7条 其他</span>

7.1本司网站所有者是指在政府部门依法许可或备案的本司网站经营主体。

7.2如因不可抗力或其它本站无法控制的原因使本站活动服务无法及时提供或无法按本协议进行的，本司会合理地尽力协助处理善后事宜。

7.3用户除遵守该用户协议外，仍应同时遵守《本司用户注册协议》。

<b style="color:#000; font-weight: 700;">7.4本协议内容中以黑体、加粗、下划线、斜体等方式显著标识的条款，请用户着重阅读。</b>

协议生效日期：2024年02月19日
`
            }).then(() => {
                // on confirm
                this.checked = true
            }).catch(() => {
                // on cancel
            });
        },
    }
}
</script>
<style lang="less" scoped>
.page {
    padding-bottom: 170px;
    width: 100%;
    background: #F2F2F4;
    padding-top: 10px;
    font-family: PingFangSC, PingFang SC;

    .top,
    .order {
        margin: 10px;
        background: #fff;
        border-radius: 12px;
        padding: 15px 20px;
        margin-top: 0;
    }

    .img-flex {
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;

        .items {
            flex: 1;

            img {
                width: 58px;
                height: 58px;
            }

            .title {
                margin: 5px 0 10px;
                color: #EEC897;
                font-size: 15px;
                line-height: 20px;
            }

            .small-title {
                color: #9F9F9F;
                font-size: 14px;
                font-weight: 400;
            }
        }
    }

    .order {
        .order-flex {
            display: flex;
            justify-content: center;
            align-items: center;
            text-align: center;

            .order-item {
                border: 1px solid #D4D4D4;
                border-radius: 12px;
                padding: 12px;
                flex: 1;
                max-width: 22%;
                &:nth-child(2n) {
                    margin: 0 14px;
                }
            }

            .acvite {
                border: 1px solid #C6AC46;
                background: #F7E083;

                .order-name {
                    color: #4C2D10;
                }
            }

            .order-name {
                color: #2B2B2B;
                font-size: 16px;
                line-height: 22px;
            }

            .order-price {
                color: #F10804;
                font-size: 16px;
                line-height: 22px;
                margin-top: 22px;
            }
        }
    }

    .order1 {
        margin: 10px;
        background: #fff;
        border-top-left-radius: 12px;
        border-top-right-radius: 12px;
        margin-top: 0;
    }

    .btn-flex {
        .btn-t {
            background: #F7E083;
            display: flex;
            border-radius: 12px;
            padding: 14px;
            align-items: center;

            .left {
                width: 70%;

                .left-n {
                    color: #4C2D10;
                    font-size: 16px;
                    margin-bottom: 8px;
                    line-height: 22px;
                    display: flex;
                    align-items: center;
                    font-weight: 600;

                    img {
                        margin-left: 10px;
                        width: 19px;
                        height: 19px;
                    }
                }

                .left-m {
                    background: #fff;
                    border-radius: 12px;
                    padding: 9px 10px;
                    width: 175px;
                    color: #171717;
                    font-size: 14px;
                    line-height: 20px;

                    span {
                        padding-left: 10px;
                        font-family: OPPOSans20_Bold;
                        color: #CA4B38;
                    }
                }
            }

            .right {
                width: 30%;
                text-align: center;
                height: 36px;
                line-height: 36px;
                background: #F6CC44;
                border-radius: 18px;
                color: #4C2D10;
            }
        }

        .btn-f {
            margin: 20px 18px 17px 15px;
            color: #141414;
            line-height: 20px;
            padding-bottom: 17px;
        }
    }

    .footer {
        background: #fff;
        text-align: center;
        padding-top: 25px;
        padding-bottom: 21px;
        position: fixed;
        bottom: 0;
        width: 100%;

        .sumbit {
            margin: 0 21px;
            background: #F8DA82;
            border-radius: 24px;
            text-align: center;
            height: 48px;
            line-height: 48px;
            color: #874F10;
            font-size: 20px;
            font-weight: 600;
            margin-bottom: 9px;
        }

        .d-v {
            color: #262626;
            font-size: 12px;

            span {
                color: #8C8C8C;
            }
        }

        .f-v {
            color: #616161;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 8px;

            span {
                color: #9E8969;
            }

            .van-checkbox {
                margin-right: 6px;
            }
        }
    }

}








.shareit {
  -webkit-user-select: none;
  position: fixed;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.8);
  text-align: center;
  top: 0;
  left: 0;
  z-index: 999;
}

.shareit img {
  max-width: 100%;
}

.arrow {
  width: 100px;
  height: 150px;
  position: absolute;
  right: 5%;
  top: 1%;
}

.follow {
  margin-right: 6px;
  margin-left: 30px;
  width: 90%;
  // height: 100rpx;
  line-height: 30px;
  // text-align: left;
  text-decoration: none;
  font-size: 18px;
  color: white;
  float: left;
  margin-top: 180px;
}
</style>